import React, { Component, useEffect, useState } from 'react';
import {CatPanelIcon, ClsIcon, setCatIcon} from '../common/Icons';
import EntityPanel from '../common/EntityPanel';
import { useTranslation } from 'react-i18next';

function CatPanel(props) {
  const {t}=useTranslation();
  const [pathItems,setPathItems]=useState([]);
  const values=[
	{key:t('Id'),value:props.cat.id},
	{key:t('Path'),value:props.cat.path}
  ];
  useEffect(()=>{
    var path=[];
    //path.push({name:'ROOT',link:'/cat/0'});
    [...props.cat.parents].reverse().forEach((el) => {
        //if(el.id!=props.cat.id)
            path.push({name:el.name,link:'/cat/'+el.id});
    });
    setPathItems(path);
  },[props]);
  const onSelect=(link)=>{
    var cat=null;
    props.cat.parents.forEach(el => {
        if('/cat/'+el.id==link)
            cat=el;
    });
    if(cat)
    {
        setCatIcon(cat);      
        props.openPage(cat);
    }
  }
  return(
	<EntityPanel header={props.cat.name} values={values} icon={<CatPanelIcon large icon={props.cat.icon}/>} pathItems={pathItems} onSelect={onSelect}/> 
	)
}

export default CatPanel;